// extracted by mini-css-extract-plugin
module.exports = {"modal":"account-setting_modal__OGW5J"};